import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Row } from 'react-table';
import ExpandRowFormatter from '../formatters/expand-row-formatter';
import './collapsable-row-component.scss';

type CollapsableRowProps = {
  row: Row;
};

export default function CollapsableRow({ row }: CollapsableRowProps): JSX.Element {
  const [isRowOpen, setIsRowOpen] = useState(false);

  const toggleOpenRow = () => {
    setIsRowOpen(!isRowOpen);
  };

  return (
    <>
      <tr role="row" className="collapse-row cursor-pointer default-row" onClick={toggleOpenRow}>
        {row.cells.map((cell, index) => {
          return index === row.cells.length - 1 ? (
            <td role="cell" key={cell.column.id}>
              <div className="chevron">
                {isRowOpen ? (
                  <FontAwesomeIcon icon={faChevronUp as IconProp} size="1x" />
                ) : (
                  <FontAwesomeIcon icon={faChevronDown as IconProp} size="1x" />
                )}
              </div>
            </td>
          ) : (
            <td key={cell.column.id} className={`${cell.column.id}-table`}>
              <div className="cell-container">{cell.render('Cell')}</div>
            </td>
          );
        })}
      </tr>
      <tr role="row" className="collapse-row expanded-row">
        <ExpandRowFormatter isRowOpen={isRowOpen} row={row} />
      </tr>
      <tr className="spacer" />
    </>
  );
}
